import { createStubImplementation } from '@ardoq/stub-implementation';
import { ARDOQ_DEFAULT_LOCALE } from './locales';
import { Locale } from './types';

type GetCurrentLocale = () => Locale;

export type LocaleImplementation = {
  getCurrentLocale: GetCurrentLocale;
};

export const defaultImplementation: LocaleImplementation = {
  getCurrentLocale: () => ARDOQ_DEFAULT_LOCALE,
};

export const { getCurrentLocale, registerImplementation } =
  createStubImplementation('@ardoq/locale', defaultImplementation);
